import { combineReducers } from 'redux';

import * as actionTypes from '../aciton-mgr/actionTypes';
import { defaultPageSize } from '../../helpers/constants';

const keyword = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SET_KEYWORD:
      return action.keyword;
    default:
      return state;
  }
}

const bufferedKeyword = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SET_BUFFERED_KEYWORD:
      return action.keyword;
    default:
      return state;
  }
}

const totalRecord = (state = 0, action) => {
  switch (action.type) {
    case actionTypes.SEARCH_SUCCESS:
      return action.startIndex === 0 ? action.totalRecord : state;
    default:
      return state;
  }
}

const totalPages = (state = 0, action) => {
  switch (action.type) {
    case actionTypes.SEARCH_SUCCESS:
      return action.totalPage
    default:
      return state;
  }
}

const currentPage = (state = 0, action) => {
  switch (action.type) {
    case actionTypes.CHANGE_PAGINATION_PAGE:
      return action.currentPage;
    case actionTypes.SEARCH_SUCCESS:
      return action.startIndex;
    default:
      return state;
  }
}

const rowsPerPage = (state = defaultPageSize, action) => {
  switch (action.type) {
    case actionTypes.CHANGE_PAGINATION_ROWS_PER_PAGE:
      return action.rowsPerPage;
    default:
      return state;
  }
}

const openedDetailDialog = (state = false, action) => {
  switch (action.type) {
    case actionTypes.SELECT_ERROR_REPORT:
      return true;
    case actionTypes.TOGGLE_DETAIL_DIALOG:
      return !state;
    default:
      return state;
  }
}

const isSearching = (state = false, action) => {
  switch (action.type) {
    case actionTypes.SEARCH_REQUEST:
      return true;
    case actionTypes.SEARCH_FAILURE:
    case actionTypes.SEARCH_SUCCESS:
      return false;
    default:
      return state;
  }
}

export default combineReducers({
  keyword,
  bufferedKeyword,
  totalRecord,
  totalPages,
  currentPage,
  rowsPerPage,
  openedDetailDialog,
  isSearching
});

const getCurrentState = state => state.errorReports.reportSearchForm;

export const getKeyword = state => getCurrentState(state).keyword

export const getBufferredKeyword = state => getCurrentState(state).bufferedKeyword

export const getTotalRecord = state => getCurrentState(state).totalRecord;

export const getTotalPages = state => getCurrentState(state).totalPages;

export const getCurrentPage = state => getCurrentState(state).currentPage;

export const getRowsPerPage = state => getCurrentState(state).rowsPerPage;

export const getOpenedDetailDialog = state => getCurrentState(state).openedDetailDialog;

export const getIsSearching = state => getCurrentState(state).isSearching;